export default __webpack_public_path__ + "assets/h1.7fe6de15.svg";